module.exports = __webpack_public_path__ + "img/donante-mona.b1f90a3f.jpeg";